export const REQUEST_FOR_UNPROCESSED_DATA_FOR_LEGAL_MODERATION = 'REQUEST_FOR_UNPROCESSED_DATA_FOR_LEGAL_MODERATION';
export const RESPONSE_OF_UNPROCESSED_DATA_FOR_LEGAL_MODERATION = 'RESPONSE_OF_UNPROCESSED_DATA_FOR_LEGAL_MODERATION';
export const POST_PROCESSED_LEGAL_DATA_TO_SERVER = "POST_PROCESSED_LEGAL_DATA_TO_SERVER";
export const RESPONSE_POST_PROCESSED_LEGAL_DATA_TO_SERVER = "RESPONSE_POST_PROCESSED_LEGAL_DATA_TO_SERVER";

export const requestUnporcessedLegalDataForModeration = (data) => {
    return {
        type: REQUEST_FOR_UNPROCESSED_DATA_FOR_LEGAL_MODERATION,
        data
    }
}

export const responseOfUnprocessedData = (data) => {
    return {
        type: RESPONSE_OF_UNPROCESSED_DATA_FOR_LEGAL_MODERATION,
        data
    }
}

export const postProcessedDataToServer  = ( data ) => {
    return { 
        type : POST_PROCESSED_LEGAL_DATA_TO_SERVER,
        data
    }
}

export const responseOfpostProcessedDataToServer  = ( data ) => {
    return { 
        type : RESPONSE_POST_PROCESSED_LEGAL_DATA_TO_SERVER,
        data
    }
}


export const REQUEST_FOR_UNPROCESSED_DATA_FOR_ADDITIONAL_LEGAL_MODERATION = 'REQUEST_FOR_UNPROCESSED_DATA_FOR_ADDITIONAL_LEGAL_MODERATION';
export const RESPONSE_OF_UNPROCESSED_DATA_FOR_ADDITIONAL_LEGAL_MODERATION = 'RESPONSE_OF_UNPROCESSED_DATA_FOR_ADDITIONAL_LEGAL_MODERATION';
export const POST_PROCESSED_ADDITIONAL_LEGAL_DATA_TO_SERVER = "POST_PROCESSED_ADDITIONAL_LEGAL_DATA_TO_SERVER";
export const RESPONSE_POST_PROCESSED_ADDITIONAL_LEGAL_DATA_TO_SERVER = "RESPONSE_POST_PROCESSED_ADDITIONAL_LEGAL_DATA_TO_SERVER";

export const requestUnprocessedAdditionalLegalDataForModeration = (data) => {
    return {
        type: REQUEST_FOR_UNPROCESSED_DATA_FOR_ADDITIONAL_LEGAL_MODERATION,
        data
    }
}

export const responseOfUnprocessedAdditionalLegalData = (data) => {
    return {
        type: RESPONSE_OF_UNPROCESSED_DATA_FOR_ADDITIONAL_LEGAL_MODERATION,
        data
    }
}

export const postProcessedAdditionalLegalDataToServer  = ( data ) => {
    return { 
        type : POST_PROCESSED_ADDITIONAL_LEGAL_DATA_TO_SERVER,
        data
    }
}

export const responseOfpostProcessedAdditionalLegalDataToServer  = ( data ) => {
    return { 
        type : RESPONSE_POST_PROCESSED_ADDITIONAL_LEGAL_DATA_TO_SERVER,
        data
    }
}

export const DOWNLOAD_LEGAL_BULK_DELETE_TEMPLATE = "DOWNLOAD_LEGAL_BULK_DELETE_TEMPLATE";
export const UPLOAD_LEGAL_BULK_DELETE_EXCEL = "UPLOAD_LEGAL_BULK_DELETE_EXCEL";
export const RESPONSE_UPLOAD_LEGAL_BULK_DELETE_EXCEL = "RESPONSE_UPLOAD_LEGAL_BULK_DELETE_EXCEL";

export const downloadLegalBulkDeleteTemplate = (counterpartyId, callback) => ({
    type: DOWNLOAD_LEGAL_BULK_DELETE_TEMPLATE,
    counterpartyId,
    callback
});

export const SET_EXCEL_DOWNLOADING = 'SET_EXCEL_DOWNLOADING';
export const setExcelDownloading = (status) => ({
    type: SET_EXCEL_DOWNLOADING,
    payload: status
});
export const uploadBulkDeleteExcel = (data) => {
    return {
        type: UPLOAD_LEGAL_BULK_DELETE_EXCEL,
        data
    }
}

export const responseOfUploadBulkDeleteExcel = (data) => {
    return {
        type: RESPONSE_UPLOAD_LEGAL_BULK_DELETE_EXCEL,
        data
    }
}